export enum TPopperTriggerEvent {
  HOVER = 'hover',
  CLICK = 'click',
}
